<template>
  <div class="cargo-pop-select-input">
    <el-input no="displayName" :style="`width: ${inputWidth};`" :value="displayName ? displayName : eventName" @click.native="dialogVisible=true" />
    <el-dialog
      no="selectMultiDialog"
      :title="title"
      :visible.sync="dialogVisible"
      width="1160px"
      append-to-body
    >
      <div class="select-dialog" style="display: flex; margin: 10px">
        <span style="align-self:center; margin-right: 5px">{{ filterLabel }}  </span>
        <el-input v-model="searchValue" :placeholder="$t('SeaExport.PleaseInputAKeyword')" style="width: 300px" />

        <span v-if="showOffice" style="align-self:center; margin-left: 15px; margin-right: 5px">{{ $t('CargoMsg.Cargo_SelectBranch') }}  </span>
        <el-select v-if="showOffice" ref="select" v-model="branchIds" multiple filterable style="width: 218px" @visible-change="onVisibleChange">
          <el-option :value="0" :label="$t('Message.All')" />
          <el-option
            v-for="office in currentOfficeList"
            :key="office.uuid"
            :value="office.officeId"
            :label="office.code"
          />
        </el-select>
        <el-button size="mini" type="primary" style="margin-left: 5px;" @click="showBranchSelectDialog">...</el-button>

      </div>
      <div class="grid">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :grid-options="gridOptions"
          :row-data="filterData"
          :show-side-bar="false"
          style="height:100%;min-height: 400px;"
        />
      </div>
      <template slot="footer">
        <div style="display: flex;text-align: left;">
          <span class="blue">{{ $t('CargoMsg.Cargo_CurrentSelection') }}:</span>
          <div style="flex: 1;height: 28px;overflow-y: auto;text-align: left;word-break: break-word;margin-left: 5px">
            {{ displayName ? displayName : eventName }}
          </div>
        </div>
        <div>
          <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button @click="onReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
          <el-button @click="handleClose">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </div>
      </template>
      <!-- 分公司选择弹窗 -->
      <branch-select-dialog :append-to-body="true" :visible.sync="branchSelectDialog.visible" :value="branchSelectDialog.value" :office-list="currentOfficeList" @callback="branchSelectDialog.callback" />
    </el-dialog>
  </div>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import lang from '@/lang'
import { getUserInfo } from '@/utils/auth'
import BranchSelectDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/BranchSelectDialog'

export default {
  name: 'SelectMultiDialog',
  components: { CargoAgGrid, BranchSelectDialog },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    columnDefs: {
      type: Array,
      default: () => []
    },
    rowData: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    eventName: {
      type: String,
      default: () => ''
    },
    filterKeys: {
      type: Array,
      default: () => ['code', 'englishName', 'chineseName']
    },
    displayNameField: {
      type: String,
      default: () => 'fieldName'
    },
    inputWidth: {
      type: String,
      default: () => '390px'
    },
    filterLabel: {
      type: String,
      default: () => lang.t('CargoMsg.Cargo_Query')
    },
    showOffice: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      isAll: false,
      dialogVisible: false,
      searchValue: '',
      selectedRows: null,
      selectedTempRows: null,
      displayName: '',
      gridOptions: {
        rowSelection: 'multiple',
        onSelectionChanged: (event) => {
          this.updateSelect()
        }
      },
      selectedData: null,
      selectedBak: '',
      branchIds: [],
      branchSelectDialog: {
        visible: false,
        value: [],
        callback: () => {}
      },
      branchIdsIsEdit: false
    }
  },
  computed: {
    filterData() {
      const { searchValue, rowData, branchIds } = this
      if (!searchValue.trim()) {
        if (branchIds && branchIds.length > 0 && !branchIds.includes(0)) {
          return rowData.filter(row => branchIds.includes(row.officeId))
        }
        return rowData
      } else {
        const filterKeys = this.filterKeys
        return rowData.filter(row => {
          if (branchIds && branchIds.length > 0 && !branchIds.includes(0)) {
            if (!branchIds.includes(row.officeId)) {
              return false
            }
          }
          for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i]
            if (row[key] && row[key].toLowerCase().indexOf(searchValue.trim().toLowerCase()) !== -1) return true
          }
        })
      }
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      if (newVal) {
        if (this.value && this.value.length > 0) {
          const map = {}
          for (const item of this.value) {
            map[item] = true
          }
          this.gridCheck(this.rowData, map, true)
        }
      }
    },
    filterData(newList) {
      if (newList && this.rowData && newList.length === this.rowData.length) {
        return
      }
      this.reCheckGrid(newList)
    },
    // displayName() {
    // console.log('finale displayName:', this.displayName)
    // },
    branchIds() {
      this.$nextTick(() => {
        this.onVisibleChange(this.branchIdsIsEdit)
      })
    }
  },
  methods: {
    reCheckGrid(list) {
      if (this.selectedRows && this.selectedRows.length > 0) {
        const map = {}
        for (const item of this.selectedRows) {
          map[item.uuid] = true
        }
        this.gridCheck(list, map, false)
      }
    },
    gridCheck(list, map, resetDisplayName = false) {
      for (const row of list) {
        if (map[row.uuid]) {
          row.checked = true
        }
      }
      this.$nextTick(() => {
        this.gridOptions.api.forEachLeafNode((node) => {
          if (node.data['checked']) {
            node.setSelected(true)
            delete node.data.checked
          } else {
            node.setSelected(false)
          }
        })
        if (resetDisplayName) {
          this.selectedRows = this.gridOptions.api.getSelectedRows()
          this.displayName = this.displayNameLabel()
        }
      })
    },
    onSave() {
      this.$emit('change', this.selectedRows || [])
      this.dialogVisible = false
      this.searchValue = ''
      this.branchIds = []
    },
    onReset() {
      this.selectedBak = ' '
      this.selectedData = null
      this.displayName = ' '
      this.searchValue = ''
      this.branchIds = []
      this.$forceUpdate()
      if (this.gridOptions.api) {
        this.gridOptions.api.forEachLeafNode((node) => {
          node.setSelected(false)
        })
        this.gridOptions.api.clearFocusedCell()
      }
    },
    handleClose() {
      this.selectedData = null
      this.searchValue = ''
      this.branchIds = []
      this.displayName = ''
      this.dialogVisible = false
    },
    displayNameLabel() {
      const selectRows = this.selectedRows
      const nameList = []
      for (const selectRow of selectRows) {
        nameList.push(selectRow[this.displayNameField])
      }
      return nameList.sort().join(',')
    },
    updateSelect() {
      // 缓存当前已选择的数据
      // 之前选中的数据
      const oldSelectRows = this.selectedRows
      // 保留不在数据源的部分
      const oldRows = oldSelectRows && oldSelectRows.length > 0 ? oldSelectRows.filter(item => {
        return !this.filterData.includes(item)
      }) : []
      const newSelectRows = this.gridOptions.api.getSelectedRows()
      this.selectedRows = oldRows.concat(newSelectRows)
      this.displayName = this.displayNameLabel() || ' '
    },
    // 分公司 查询项相关
    onVisibleChange(isEdit) {
      this.branchIdsIsEdit = isEdit
      this.convertMultiSelectedToText()
    },
    convertMultiSelectedToText() {
      this.$nextTick(() => {
        const select = this.$refs.select
        const tags = select.$el.querySelector('.el-select__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let input = null
        for (const child of tags.childNodes) {
          if (!child.classList) {
            continue
          }
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-select__input')) {
            input = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (input) {
            input.style.display = ''
            input.value = ''
            input.setAttribute('placeholder', this.getMultiDisplay(input.offsetWidth))
            input.focus()
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getMultiDisplay(customDisplay.offsetWidth)
          customDisplay.setAttribute('title', this.getMultiDisplay())
          if (input) {
            input.style.display = 'none'
          }
        }
      })
    },
    getMultiDisplay(width) {
      const texts = []
      for (const branchId of this.branchIds) {
        if (branchId === 0) {
          texts.push(this.$t('Message.All'))
          continue
        }
        const office = this.currentOfficeList.find(p => p.officeId === branchId)
        if (office) {
          texts.push(office.code)
        }
      }
      if (typeof width === 'number') {
        return this.getTextEllipsis(texts.join(','), width, 12, 9)
      }
      return texts.join(',')
    },
    getTextEllipsis(text, width, fontSize = 12, paddingWidth = 25) {
      if (width > 0) {
        const textWidth = this.getTextWidth(text, fontSize, paddingWidth)
        if (textWidth > width) {
          for (let i = 3; i <= text.length; ++i) {
            const subText = text.substring(0, i)
            const subTextWidth = this.getTextWidth(subText, fontSize, paddingWidth)
            if (subTextWidth > width) {
              return text.substring(0, i - 2) + '...'
            }
          }
        }
      }
      return text
    },
    getTextWidth(text, fontSize, paddingWidth) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `normal ${fontSize}px sans-serif`
      return ctx.measureText(text).width + paddingWidth
    },
    showBranchSelectDialog() {
      this.branchSelectDialog.value = this.branchIds
      this.branchSelectDialog.callback = val => {
        this.branchIds = val
        // this.changeOfficeHandler()
      }
      this.branchSelectDialog.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/element-variables.scss";
.cargo-pop-select-input{
  .operation {
    display: flex;
    justify-content: space-between;
  }
  .grid {
    display: flex;
    height: 460px;
  }
  .el-dialog__footer{
    display: flex;
    text-align: left;
    .blue {
      color: $--color-primary
    }
  }
}
.select-dialog::v-deep {
  .el-select {
    .el-select__tags {
      .custom-display {
        width: 100%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        margin-left: 9px;
      }
      .el-tag--info {
        display: none;
      }
      .el-select__input {
        margin-left: 9px;
        font-size: 12px;
      }
    }
  }
}
</style>
